<template>

    <div class="container">

        <div class="mb-4">
            <h1>{{ __('Kundengruppe bearbeiten') }}</h1>
        </div>

        <p>
            <a :href="customerGroup.permalink" target="_blank">{{ customerGroup.permalink }}</a>
        </p>

        <div class="">
            <form @submit.prevent="form.put(route('admin.customer-groups.update', customerGroup))">
                <form-fields :form="form" :customerGroup="customerGroup" />
            </form>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'customerGroup',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    name: this.customerGroup.name,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>